// Main class for Experience that creates everything
import * as THREE from "three"
import Sizes from "./Utils/Sizes.js"
import Time from "./Utils/Time.js"
import Camera from "./Camera.js"
import Renderer from "./Renderer.js"
import World from "./World/World.js"
import Resources from "./Utils/Resources.js"
import sources from "./sources.js"

//import Debug from "./Utils/Debug.js"

//Singleton of Experience class
let instance = null

export default class Experience{
    constructor(canvas){
        
        if(instance){
            //console.log("Experience Class Singleton")
            return instance
        }
        instance = this
        //console.log("Experience Class")

        // Options
        this.canvas = canvas

        // Setup
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.resources = new Resources(sources)
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.world = new World()

        //profanity
        //this.scene.background = new THREE.Color(0x111111)

        // Subscribe to Sizes class resize event
        //event was in the arument of the arrow function
        this.sizes.addEventListener("resize", () => {
            //console.log(event.message)
            // Funtion to run when resize event occurs
            this.resize()
        })
       
        // Subscribe to Time class tick event
        this.time.addEventListener("tick", () => {
            //console.log(event.message)
            this.update()
        })

    }

    resize(){
        this.camera.resize()
        this.renderer.resize()
    }

    update(){
        this.camera.update()
        this.world.update()
        this.renderer.update()
    }
}